import React, { createContext, useEffect, useMemo, useState, useContext } from 'react';
import { CognitoAuthContext } from './CognitoAuthContext';

export const Abc3Context = createContext();

export const Abc3Provider = ({ children }) => {
  const { user, loggedIn, handleLogout } = useContext(CognitoAuthContext);
  const [account, setAccount] = useState(null);
  const name = process.env.REACT_APP_NAME;

  useEffect(() => {
    if (user) {
      setAccount({
        username: user.username,
        email: user.email || user.signInDetails?.loginId
      });
    } else {
      setAccount(null);
    }
  }, [user]);

  const contextValue = useMemo(() => ({
    account,
    loggedIn,
    logout: handleLogout,
    name,
    user
  }), [account, loggedIn, handleLogout, name, user]);

  return (
    <Abc3Context.Provider value={contextValue}>
      {children}
    </Abc3Context.Provider>
  );
};
